import { editCases, getDeleteCases } from "../actions/cases.js";
import { GET, POST } from "./api.js";

export const cases = {
    casesConsult: (data) => GET(`/cases`, data),
    casesCreated: (data) => GET(`/cases/${data}`),
    editCase: (data) => POST(`/cases/edit`, data),
    editCases: (data) => POST(`/cases/editCases`, data),
    getCasesMenu: (data) => POST(`/cases/getCases`, data),
    getLimitsMenu: (data) => POST(`/cases/family`, data),
    getDeleteCases: (data) => GET(`/cases/getDeleteCases`, data),
    element: (data) => POST(`/cases/element`, data),

}